import { useEffect, useState } from 'react';
import { API_CODE, BOOLEAN_STATUS, SESSION_STORAGE_NAME, STATUS } from '../constants/enum';
import Api from '../store/Interceptor/index';

export const useMaintenanceStatus = () => {
  const [maintenanceStatus, setMaintenanceStatus] = useState(null);
  useEffect(() => {
    const fetchMaintenanceStatus = async () => {
      try {
        sessionStorage.removeItem(SESSION_STORAGE_NAME.SITE_MAINTENANCE_STATUS);
        const status = [BOOLEAN_STATUS.TRUE, STATUS.TRUE];
        const response = await Api.get(`${process.env.MAINTENANCE_API_URL}?app=invoice-app`);

        if (response.status === API_CODE.STATUS_200 && status.includes(response?.data?.isDowntime)) {
          sessionStorage.setItem(SESSION_STORAGE_NAME.SITE_MAINTENANCE_STATUS, BOOLEAN_STATUS.TRUE);
          setMaintenanceStatus({ message: response?.data?.message, status: BOOLEAN_STATUS.TRUE });
        } else {
          sessionStorage.setItem(SESSION_STORAGE_NAME.SITE_MAINTENANCE_STATUS, BOOLEAN_STATUS.FALSE);
          setMaintenanceStatus({ message: response?.data?.message, status: BOOLEAN_STATUS.FALSE });
        }
      } catch (err) {
        setMaintenanceStatus({ message: '', status: BOOLEAN_STATUS.FALSE });
      }
    };
    fetchMaintenanceStatus();
  }, []);
  return maintenanceStatus;
};
